import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';

import { authActions, alertActions } from '../../../_services/essentials/store';
import FormControl from "@mui/material/FormControl";
import { Button, Grid, TextField, Box, Stack, Typography, Paper, Link } from "@mui/material";
import { history } from "../../../_services/essentials/helpers";
import { ArrowForwardOutlined } from '@mui/icons-material';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
export { ForgotPassword };

function ForgotPassword() {
    const dispatch = useDispatch();

    // form validation rules
    const validationSchema = Yup.object().shape({
        email: Yup.string().trim().required('Email is required'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState, watch } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;
    const emailID = watch('email', '');
    const [EmailSent, setEmailSent] = useState(false);
    async function onSubmit({ email }) {
        try {
            // dispatch(authActions.resetPassword({ email }));
            let message = await dispatch(authActions.resetPassword_v2({ email })).unwrap();
            if (message !== 'Incorrect Username') {
                setEmailSent(true);
            }
            else
                dispatch(alertActions.warning({ message, showAfterRedirect: false }));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: { md: 'flex-end' } }}>
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    maxWidth: '380px',
                    p: { xs: 2, md: 2 },
                    borderRadius: 4,
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '580px',
                    alignContent: 'center',
                    alignItems: 'center',
                }}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    {!EmailSent ? (
                        <Box sx={{
                            width: '100%'
                        }}
                        >
                            <Typography variant="h5" component="h3" sx={{ fontWeight: 700, color: '#1a1068', mb: 0.5 }}>
                                Forgot your Password?
                            </Typography>
                            <Stack direction={"column"}
                                sx={{
                                    justifyContent: 'space-between', width: '100%', maxWidth: '365px', mt: 4
                                }}
                            >
                                <FormControl fullWidth>
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Enter your email
                                    </Typography>
                                    <TextField
                                        id="email"
                                        type="text"
                                        name="email"
                                        placeholder="your@email.com"
                                        autoComplete="off"
                                        autoFocus
                                        fullWidth
                                        variant="outlined"
                                        slotProps={{
                                            input: {
                                                sx: {
                                                    mb: 2,
                                                    bgcolor: '#ffffff',
                                                    borderRadius: 2,
                                                    height: '40px',
                                                    maxWidth: '350px',
                                                    width: '100%'
                                                }
                                            }
                                        }}
                                        defaultValue={""}
                                        {...register('email', { required: true })}
                                        error={Boolean(errors.email)}
                                        helperText={errors.email ? errors.email.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                    />
                                </FormControl>
                                <Stack direction={"row"}
                                    sx={{
                                        justifyContent: 'space-between',
                                        // p: 2,
                                        width: '97%',
                                        mb: 2
                                    }}
                                >
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        endIcon={<ArrowForwardOutlined />}
                                        sx={{
                                            borderRadius: '16px', width: '100%', textTransform: 'uppercase',
                                            fontWeight: '300', fontSize: '18px', height: '40px'
                                        }}
                                    >
                                        Send Password
                                    </Button >
                                </Stack>

                            </Stack>
                        </Box>) : (
                        <Stack direction={"column"}
                            sx={{
                                justifyContent: 'center', width: '100%',
                            }}
                        >
                            <Stack direction={"row"}
                                sx={{
                                    justifyContent: 'center',
                                    // p: 2,
                                    mb: 2
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: '600', fontSize: '25px' }}
                                >
                                    Email Send
                                </Typography>
                            </Stack>
                            <Stack direction={"row"}
                                sx={{
                                    justifyContent: 'center',
                                    // p: 2,
                                    mb: 2
                                }}
                            >
                                <MarkEmailReadOutlinedIcon fontSize='large'
                                    style={{ height: '106px', width: '106px', justifyContent: 'center', color: '#39B84D' }}

                                />
                            </Stack>
                            <Stack direction={"row"}
                                sx={{
                                    justifyContent: 'center',
                                    // p: 2,
                                    mb: 2
                                }}
                            >
                                <Typography variant='body1' sx={{ mb: 0.5, width: '75%' }}>
                                    We have sent email to {emailID},
                                    Please check your inbox.
                                </Typography>
                            </Stack>
                        </Stack>
                    )}
                    <Stack direction={"row"}
                        sx={{
                            justifyContent: 'flex-end',
                            p: 2,
                            width: '100%'
                        }}
                    >
                        <Link
                            onClick={() => history.navigate(-1)}
                            variant="body2"
                            sx={{ alignSelf: 'right', cursor: 'pointer' }}
                        >
                            Back to Login
                        </Link>
                    </Stack>
                </form>
            </Paper>
        </Grid>
    )
}